import sidePanel from "side-panel-menu-thing";
// import axios from 'redaxios';
import ReactCalculator from "./components/react-calculator.svelte";
import NewsSection from "./components/news-section.svelte";
import NewsletterPopup from "./components/newsletter-popup.svelte";
import EventsCalendar from "./components/events-calednar.svelte";
import { tns } from "../../node_modules/tiny-slider/src/tiny-slider";
import { async } from "rxjs/internal/scheduler/async";

const $ = window.jQuery;

// start jquery init
$(function () {
  const ScrollReveal = require("./lib/scroll-reveal");
  const helpers = require("./lib/helpers");

  const $body = $("body");
  const $html = $("html");
  const $panel = $("#panel");

  // const isLargeScreen = window.innerWidth > 1100
  const particlesJSON = require("./lib/particlesjs-config2");
  const { login_form_object, NProgress, _lload } = window;
  let sticky;
  let waypoints;
  let heroHeight;
  let $heroBackground;
  let initialized;
  let smoothState;

  initialScripts();

  // loads required gravity forms js for gravity forms ajax. Must deregister normal gravity forms scripts and use w/ the gform_cdata_open / close filters in functions.php (see aspg)
  window.loadGformScripts = function () {
    if (!window.gformInitSpinner) {
      _lload(
        "https://cdn.jsdelivr.net/combine/gh/wp-premium/gravityforms/js/gravityforms.min.js,gh/wp-premium/gravityforms/js/jquery.json.min.js",
        window.initGravityForms
      );
    } else {
      window.initGravityForms();
    }
  };

  // if (!window.gformInitSpinner) {
  // 	window.gformInitSpinner = function () {
  // 		setTimeout(() => {
  // 			window.gformInitSpinner()
  // 		}, 999)
  // 	}
  // }

  // jquery deferred example
  // var testy = $.Deferred()
  // testy.then(function() {
  // 	alert('resolved')
  // })
  // setTimeout(function() {
  // 	testy.resolve()
  // }, 4000)

  function classFunnel($el) {
    if ($el.is(".home")) {
      homePage();
    } else if ($el.is(".page-template-distributors")) {
      distributorsPage();
    } else if ($el.is(".page-template-products, .tax-product_category")) {
      productCatPage();
    } else if ($el.is(".single-product")) {
      singleProductPage();
    } else if ($el.is(".page-template-about")) {
      aboutPage();
    } else if ($el.is(".author")) {
      userPage();
    } else if ($el.is(".page-template-request-trial")) {
      requestATrial();
    }
    commonScripts();
  }

  classFunnel($("#panel_inner"));

  function initialScripts() {
    // init off canvas nav
    const mobileMenu = new sidePanel({
      target: $body[0],
      props: {
        target: $body[0],
        content: document.getElementById("menu"),
        fixed: true,
        width: 320,
        left: true,
      },
    });

    let smoothStateOpts = {
      // prefetch: true,
      // scroll: false,
      cacheLength: 99,
      scroll: true,
      blacklist: "form, .login-btn > a, .logout-link a",
      onStart: {
        duration: 170, // Duration of our animation
        render: function ($container) {
          // Add your CSS animation reversing class
          $html.addClass("is-exiting ss-active");

          // cleanup
          if ($heroBackground && $heroBackground.length) {
            $heroBackground.css({
              transform: "translateY(0)",
            });
          }
          if (waypoints) {
            waypoints.forEach((waypoint) => waypoint.destroy());
            waypoints = false;
          }
          if (sticky) {
            sticky.destroy();
            sticky = false;
          }

          // setTimeout(() => {
          // if ($html.is('.is-exiting')) {
          NProgress.start();
          // }
          // }, 50)

          // Restart your animation
          smoothState.restartCSSAnimations();
        },
      },
      onReady: {
        duration: 0,
        render: function ($container, $newContent) {
          // Remove your CSS animation reversing class
          setTimeout(() => {
            NProgress.done();
            $html.removeClass("is-exiting");
            $body.attr("style", $newContent.attr("style"));
            $body[0].className = $newContent[0].className;
            $container.html($newContent);
            // Inject the new content
            let $panelInner = $("#panel_inner");
            classFunnel($panelInner);
            heroParallax();
          }, 1);
        },
      },
      onAfter: function () {
        var $hash = $(window.location.hash);
        if ($hash.length) {
          var offsetTop = $hash.offset().top;
          window.scroll({
            top: offsetTop,
            behavior: "smooth",
          });
        }
      },
    };
    smoothState = $("#panel").smoothState(smoothStateOpts).data("smoothState");

    // toggle / close mobile menu
    $(document).on("click", "#toggle_nav", mobileMenu.show);

    $(document).on(
      "click",
      ".menu-section .menu-item-has-children > a",
      function (e) {
        e.preventDefault();
        let $el = $(this);
        $el.parent().toggleClass("show-subnav");
      }
    );

    $(document).on("click", ".menu a", function (e) {
      let $this = $(this);
      let $parent = $this.parent();
      if ($parent.hasClass("logout-link")) {
        return;
      }
      e.preventDefault();
      if (!$parent.hasClass("login-btn")) {
        let url = $this.attr("href");
        smoothState.load(url);
      }
      mobileMenu.hide();
    });

    // gravity forms nprogress
    // $(document).on('click', 'input.gform_button', function () {
    // 	NProgress.start()
    // })

    // header submenus
    // remove active classes on mouseleave
    // $('.header-links').on('mouseleave', function () {
    // 	$(this).find('.active').removeClass('active')
    // })
    // assign first li as active on hover
    $(document).on(
      "mouseenter",
      ".header-links > li > .sub-menu > li",
      function () {
        const $el = $(this).find(".sub-menu>li:first-of-type");
        $el.addClass("active");
      }
    );
    // remove active classes on li mouseleave
    $(document).on(
      "mouseleave",
      ".header-links > li > .sub-menu > li",
      function () {
        const $els = $(this).find(".sub-menu>li");
        $els.removeClass("active");
      }
    );
    // add active to li and remove others
    $(document).on(
      "mouseover",
      ".header-links > li > .sub-menu > li > .sub-menu > li",
      function () {
        const $this = $(this);
        $this.parent().find(">li").removeClass("active");
        $this.addClass("active");
      }
    );

    // search
    initSearch();

    // register form stuff if not logged in
    login_form_object && loginFormStuff();

    // cookie consent
    window.cookieconsent.initialise({
      palette: {
        popup: {
          background: "#000",
        },
        button: {
          background: "#f1d600",
        },
      },
      content: {
        href: "/privacy-policy",
      },
    });

    heroParallax();

    // class to hide outlines if not using keyboard
    $body.on("mousedown", function () {
      $body.addClass("using-mouse");
    });
    $body.on("keydown", function () {
      $body.removeClass("using-mouse");
    });

    setupNewsletterForm();

    initialized = true;
  }

  function initSearch() {
    let lastFocusedElement;

    function initEvents() {
      $(document).on("click", ".search-toggle", openSearch);
      $(document).on("click", "#btn-search-close", closeSearch);
      // openCtrl.on('click', openSearch)
      // closeCtrl.on('click', closeSearch)
      $(document).on("submit", ".search__form", function (e) {
        e.preventDefault();
        let val = $(".search__input").val();
        setTimeout(() => {
          smoothState.load(`/?s=${val}`);
        }, 350);
        closeSearch();
      });
      document.addEventListener("keyup", function (ev) {
        // escape key.
        if (ev.keyCode == 27) {
          closeSearch();
        }
      });
    }

    function openSearch() {
      lastFocusedElement = document.activeElement;
      $(".main-wrap").eq(0).addClass("main-wrap--hide");
      $(".search-section").eq(0).addClass("search--open");
      setTimeout(function () {
        $(".search__input").eq(0)[0].focus();
      }, 500);
    }

    function closeSearch() {
      $(".main-wrap").eq(0).removeClass("main-wrap--hide");
      $(".search-section").eq(0).removeClass("search--open");
      $(".search__input").eq(0)[0].blur();
      $(".search__input").eq(0).val("");
      if (lastFocusedElement) {
        // restore focus
        lastFocusedElement.focus();
      }
    }

    initEvents();
  }

  function heroParallax() {
    $heroBackground = $(".hero-background");

    function setHeroPos() {
      let scrolled = window.scrollY;
      if (scrollY < heroHeight) {
        // update position
        $heroBackground.css({
          transform: `translateY(${scrolled / 4.5}px)`,
        });
      }
    }

    function onScroll() {
      window.requestAnimationFrame(setHeroPos);
    }

    if ($heroBackground.length) {
      heroHeight = 0;
      $heroBackground.each(function () {
        heroHeight += $(this).outerHeight();
      });

      // run only once
      if (!initialized) {
        $(window).on("scroll", onScroll);
      }
      // get new height every page load
      setHeroPos();
    }
  }

  // function heroParallax() {
  // 	let $heroBackground = $('.hero-background')
  // 	let heroHeight
  // 	if ($heroBackground.length) {
  // 		heroHeight = $heroBackground.outerHeight()

  // 		function setHeroPos() {
  // 			console.log('hello')
  // 			let scrolled = window.scrollY
  // 			if (scrollY < heroHeight) {
  // 				// update position
  // 				$heroBackground.css({
  // 					transform: `translateY(${scrolled / 4}px)`
  // 				})
  // 			}
  // 		}
  // 		setHeroPos()
  // 		$(window).on('scroll', () => window.requestAnimationFrame(setHeroPos))
  // 	}
  // }

  function homePage() {
    //slick
    const $homeProductSlider = $("#homeProductSlider");
    if ($homeProductSlider.length) {
      tns({
        container: "#homeProductSlider",
        items: 4,
        slideBy: 1,
        autoplay: false,
        nav: false,
        autoplayButtonOutput: false,
        autoplayHoverPause: true,
        speed: 750,
        mouseDrag: false,
        controls: true,
        touch: true,
        controlsText: [
          '<span class="sr-only">prev</span><svg viewBox="0 0 3757.2 3511.5"><path d="M3694.9 60.5l7.7 3414.2-2157.1-1702.9L3694.9 60.5zM2270.8 757.8l-1346 998.5 1368.5 1005.4 3.1 670.3L39.3 1771.8 2277.7 31l-6.9 726.8z" fill-rule="evenodd" clip-rule="evenodd"/></svg>',
          '<span class="sr-only">next</span><svg viewBox="0 0 3663.42 3885.08"><defs><style>.cls-2{isolation:isolate;font-size:3.87px;font-family:HelveticaNeue-Bold,Helvetica Neue;font-weight:700}.cls-3{letter-spacing:-.02em}.cls-4{letter-spacing:0}</style></defs><path d="M71 3459.46L63.24 45.27l2157.18 1702.84zm1424.19-697.39l1346-998.48L1472.72 758.14l-3.1-670.3 2257 1660.27L1488.2 3488.87z" transform="translate(-63.24 396.21)" fill-rule="evenodd"/></svg>',
        ],
        responsive: {
          1300: {
            items: 4,
          },
          800: {
            items: 3,
          },
          600: {
            items: 2,
          },
          320: {
            items: 1,
          },
        },
      });
    }

    //rest of page
    const $gridItems = $(".home-icons .grid-item");
    const $displayItems = $(".callout-black-inner");
    const $callout = $(".callout-black");
    let index;
    let initialHeight = $displayItems.eq(0).height();
    helpers.startCarousel();
    // helpers.particleEngine()
    window.particlesJS("projector", particlesJSON);

    $callout.css({
      paddingBottom: `calc(${initialHeight}px + 3rem)`,
    });
    $displayItems.eq(0).css({
      position: "absolute",
    });
    $gridItems.on("click", function () {
      const $this = $(this);
      index = $this.index();
      const { innerHeight, innerWidth } = window;
      const $activeEl = $displayItems.eq(index - 1);
      const topPosition = $activeEl[0].getBoundingClientRect().top;
      const inView = innerHeight - topPosition > 150;
      if (!inView) {
        const scrollPosition = $(
          innerWidth > 800 ? ".home-icons" : ".callout-black"
        ).offset().top;
        window.scroll(0, scrollPosition);
      }
      $body.addClass("icons-active");
      $gridItems.removeClass("active");
      $this.addClass("active");
      $body.removeClass("icon-active-2 icon-active-3");
      index > 1 && $body.addClass(`icon-active-${index}`);
      $callout.css({
        paddingBottom: `calc(${$activeEl.height()}px + 3rem)`,
      });
    });
    $(window).on("resize", function () {
      const $activeEl = $displayItems.eq(index ? index - 1 : 0);
      $callout.css({
        paddingBottom: `calc(${$activeEl.height()}px + 3rem)`,
      });
    });

    const sr = ScrollReveal({
      duration: 800,
      easing: "ease",
    });
    sr.reveal(
      $gridItems,
      {
        origin: "top",
        scale: 1,
      },
      200
    );
    sr.reveal(".in-the-news > .inner-wrap", {
      // origin: 'left',
      scale: 0.95,
      // duration: 700
    });
    sr.reveal(".bottom-callout", {
      duration: 1000,
      origin: "bottom",
      scale: 1,
    });
    // if (window.innerWidth > 1100) {
    sr.reveal(".callout-black .inner-wrap, .banner-guy", {
      duration: 1000,
      origin: "left",
      scale: 1,
    });
    // }
    sr.reveal(".partners .inner-wrap", {
      duration: 1000,
      origin: "right",
      scale: 1,
    });
  }

  function aboutPage() {
    helpers.startCarousel();
  }

  function distributorsPage() {
    // load leaflet
    let { L } = window;
    if (L) {
      makeMap();
    } else {
      _lload(
        "https://cdn.jsdelivr.net/npm/leaflet@1.3.1/dist/leaflet.js",
        function () {
          L = window.L;
          makeMap();
        }
      );
    }

    function makeMap() {
      let { map_distributors } = window;
      var distributorsMap = L.map("distributors_map", {
        scrollWheelZoom: false,
        zoomControl: false,
      }).setView([15, 0], 3);
      L.tileLayer(
        "https://api.mapbox.com/styles/v1/mapbox/dark-v9/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYm9vc3RjcmVhdGl2ZWxsYyIsImEiOiJjbGI1Y2w3bmowMjgxM3Fxc25pYWxoemUzIn0.jJuKyuaPC67lSV7kaUZvQQ",
        {
          attribution:
            'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          // maxZoom: 5,
          // minZoom: 2,
          id: "mapbox.dark",
          // accessToken: 'pk.eyJ1IjoiYm9vc3RjcmVhdGl2ZWxsYyIsImEiOiJjbGI1Y2w3bmowMjgxM3Fxc25pYWxoemUzIn0.jJuKyuaPC67lSV7kaUZvQQ'
        }
      ).addTo(distributorsMap);

      map_distributors.forEach((distributor) => {
        let {
          location_name,
          coords,
          radius,
          contact,
          phone,
          email,
          products_available,
        } = distributor;
        coords = coords.split(", ").map((coord) => Number(coord));
        let circle = L.circle(coords, {
          color: "",
          fillColor: "#0069a2",
          fillOpacity: 0.45,
          radius: radius * 100000,
        }).addTo(distributorsMap);
        const popupContent = `
					<h4>${location_name}</h4>
					<p><b>Contact:</b> ${contact}</p>
					<p><b>Phone:</b> ${phone}</p>
					<p><b>Email:</b> ${email}</p>
					<p><b>Products Available: </b> <br>${products_available}</p>
				`;
        circle.bindPopup(popupContent);
      });
      // disable panning outside map
      var southWest = L.latLng(-89.98155760646617, -180),
        northEast = L.latLng(89.99346179538875, 180);
      var bounds = L.latLngBounds(southWest, northEast);
      distributorsMap.setMaxBounds(bounds);
      distributorsMap.on("drag", function () {
        distributorsMap.panInsideBounds(bounds, {
          animate: false,
        });
      });
    }
  }

  function loginFormStuff() {
    let $loginForm = $("form#login");
    let $statusBox = $loginForm.find("p.status");
    // let lastFocusedElement

    // modal open
    $body.on("click", ".login-btn > a", function (e) {
      e.preventDefault();
      // lastFocusedElement = document.activeElement
      $body.addClass("open-modal");
      $("#username").focus();
    });

    // on form submit - send ajax data
    $loginForm.on("submit", function (e) {
      e.preventDefault();
      $statusBox.show().text(login_form_object.loadingmessage);
      let action = "ajaxlogin";
      let data = {
        action: action,
        username: $loginForm.find("#username").val(),
        password: $loginForm.find("#password").val(),
        security: $loginForm.find("#security").val(),
      };
      $.ajax({
        type: "POST",
        dataType: "json",
        url: login_form_object.ajaxurl,
        data: data,
        success: function (data) {
          $statusBox.text(data.message);
          if (data.loggedin == true) {
            if (data.redirect_url) {
              // window.location.href = data.redirect_url
              window.location.href = data.redirect_url;
            } else {
              window.location.reload();
            }
          }
        },
      });
    });

    // modal exit on escape press
    $body.on("keyup", function (e) {
      if (e.keyCode == 27 && $body.is(".open-modal")) {
        closeModal();
      }
    });

    // modal close on x click
    $body.on("click", ".modal-overlay", function (e) {
      var $target = $(e.target);
      if (
        !e.target.hasAttribute("data-close") &&
        !$target.closest("[data-close]").length &&
        $target.closest(".modal").length
      ) {
        return;
      }
      closeModal();
    });

    // modal close
    function closeModal() {
      $body.addClass("closing-modal");
      // if (lastFocusedElement) {
      // restore focus
      // 	lastFocusedElement.focus()
      // }
      window.setTimeout(function () {
        $body.removeClass("open-modal closing-modal");
      }, 300);
    }
  }

  function productCatPage() {
    const sr = ScrollReveal({
      origin: "left",
      scale: 1,
      easing: "ease",
    });
    sr.reveal(".products-grid-wrap > div", {
      duration: 900,
    });
  }

  function singleProductPage() {
    let $subnav = $(".subnav");
    let $subnavLinks = $(".subnav a");
    // scrollreveal
    const sr = ScrollReveal({
      scale: 1,
      easing: "ease",
    });
    sr.reveal(
      ".split-content-wrap .inner-wrap, .page-intro .inner-wrap, .who-uses-it .inner-wrap",
      {
        duration: 800,
        origin: "bottom",
      }
    );
    sr.reveal(".pattern-black .inner-wrap", {
      duration: 800,
      origin: "left",
    });
    sr.reveal(".ribbon .inner-wrap", {
      duration: 800,
      origin: "right",
    });
    sr.reveal(
      ".suite-item",
      {
        duration: 1000,
        origin: "bottom",
      },
      350
    );
    sr.reveal("#reqtrial", {
      duration: 1000,
      origin: "bottom",
    });

    // sticky
    if (window.innerWidth > 750) {
      sticky = new window.Waypoint.Sticky({
        element: $subnav[0],
      });
      // waypoints
      function assignActiveLink(direction) {
        let $theLink = $subnav.find(`[href='#${this.element.id}']`);
        $subnavLinks.removeClass("active");
        if (direction === "up") {
          let index = $subnavLinks.index($theLink);
          $theLink = $subnavLinks.eq(index - 1);
          if (index > 0) {
            $theLink.addClass("active");
          }
        } else {
          $theLink.addClass("active");
        }
      }
      waypoints = $(
        "#overview, #benefits, #hiw, #wui, #suite, #reqtrial"
      ).waypoint({
        handler: assignActiveLink,
        offset: "80px",
      });
    }
  }

  function userPage() {
    let $productSquares = $(".products-grid > .grid-item");
    let $newsSection = $("#news");

    if ($productSquares.length) {
      $productSquares.each(function (i, el) {
        let $productSquare = $(el);
        let $panelContent = $(el).find(".panel-content");
        let panel = new sidePanel({
          target: $body[0],
          props: {
            target: $body[0],
            content: $panelContent[0],
            fixed: true,
            width: 450,
            // left: true,
            dragOpen: false,
          },
        });
        $productSquare.on("click", function (e) {
          e.preventDefault();
          panel.show();
        });
      });
    }

    if ($newsSection.length) {
      new NewsSection({
        target: $newsSection[0],
        props: $newsSection.data(),
      });
    }

    // const mobileMenu = new sidePanel({
    // 	target: $body[0],
    // 	props: {
    // 		target: $body[0],
    // 		content: document.getElementById('menu'),
    // 		fixed: true,
    // 		width: 320,
    // 	},
    // })
  }

  function commonScripts() {
    const $EventsCalendarWrap = $(".tribe-events-widget-events-list__events");
    if ($EventsCalendarWrap.length) {
      const $mountExists = $("#event-filter-component");
      if (!$mountExists.length) {
        const $mountPoint = $("<div>", { id: "event-filter-component" });
        $mountPoint.insertBefore($EventsCalendarWrap);
      }
      new EventsCalendar({
        target: document.getElementById("event-filter-component"),
      });
    }

    const $reactCalcWrap = $("#react_calc");
    if ($reactCalcWrap.length) {
      new ReactCalculator({
        target: $reactCalcWrap[0],
      });
    }
  }
  setTimeout(() => {
    let $chatWidget = $("#chat-widget-container");
    let $cookieBanner = $(".cc-window");
    let $cookieBannerResponsive = $(".cc-floating")[0];
    let windowWidth = $(window).width();

    if (windowWidth > 520) {
      if ($cookieBannerResponsive == undefined) {
        if ($chatWidget && $cookieBanner) {
          if (!$cookieBanner.prop("style")["display"]) {
            let bannerHeight = $cookieBanner.outerHeight();
            let $cookieClose = $(".cc-dismiss");
            $chatWidget.css("margin-bottom", bannerHeight);
            $cookieClose.on("click", function () {
              $chatWidget.css({
                transition: "margin-bottom 1s ease",
                "margin-bottom": 0,
              });
            });
          }
        }
      }
    } else {
      let bannerHeight = $cookieBanner.outerHeight();
      let $cookieClose = $(".cc-dismiss");
      $chatWidget.css("margin-bottom", bannerHeight);
      $cookieClose.on("click", function () {
        $chatWidget.css({
          transition: "margin-bottom 1s ease",
          "margin-bottom": 0,
        });
      });
    }
  }, 900);
  // end jquery init
});

function setupNewsletterForm() {
  $(document).on("submit", "#cc_form", function (e) {
    e.preventDefault();
    let $form = $(this);
    let name = $form.find("#cc_name").val();
    let email = $form.find("#cc_email").val();

    if (!name || !email) {
      alert("Please fill out both fields");
      return;
    }
    let names = name.split(" ");
    let firstName = names.shift();
    let lastName = names.join(" ");

    let signupUnsuccessful;

    $form.attr("disabled", "true");

    // send to backend
    (async () => {
      try {
        const newsletterFormId = 8;
        let res = await fetch(
          ["/wp-jso", `f/v2/forms/${newsletterFormId}/submissions`].join("n/g"),
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              input_1: firstName,
              input_4: lastName,
              input_3: email,
            }),
          }
        );
        let json = await res.json();
        if (json && json.is_valid) {
          new NewsletterPopup({
            target: document.body,
            intro: true,
            props: {
              signupUnsuccessful,
            },
          });
        } else {
          signupUnsuccessful = true;
        }
      } catch {
        signupUnsuccessful = true;
      }
    })();

    // axios
    // 	.post('/wp-json/boost/v1/cc-form', {
    // 		action: 'cc_signup_form',
    // 		email,
    // 		firstName,
    // 		lastName,
    // 	})
    // 	.then((response) => {
    // 		let data = JSON.parse(response.data);
    // 		if (!data.contact_id) {
    // 			signupUnsuccessful = true;
    // 		}
    // 	})
    // 	.catch((error) => {
    // 		// console.log('error', error)
    // 		signupUnsuccessful = true;
    // 	})
    // 	.then(() => {
    // 		new NewsletterPopup({
    // 			target: document.body,
    // 			intro: true,
    // 			props: {
    // 				signupUnsuccessful,
    // 			},
    // 		});
    // 	});
  });
}

function requestATrial() {
  //Function purpose - Do not allow users to request a trial for a product that does not have a file to download
  setTimeout(() => {
    //use setTimeout to grab all values select > option after page loads (only partial values grabbed without setTimeout)
    //get products from request a trial template
    let $products = document.getElementById("requestTrialProducts");
    $products = $products.getAttribute("data-products");
    $products = JSON.parse($products); //parse products passed in data_attribute
    //get product dropdown
    let $productDropdownSelect = document.querySelectorAll(
      ".populate-products select"
    )[0];
    let $productDropdown = document.querySelectorAll(
      ".populate-products select option"
    );

    //get os value on page load
    let $operatingSystemValueOnPageLoad = document.querySelectorAll(
      ".operating-system-value option[selected]"
    )[0];
    let operatingSystemValue = $operatingSystemValueOnPageLoad.value;

    //get os select field
    let $operatingSystemSelect = document.querySelectorAll(
      ".operating-system-value select"
    )[0];
    //get custom html block on form
    let $dynamicMessage = document.querySelectorAll(".dynamic-message")[0];
    //define os dropdown value
    let optionValue;
    //get form submit button
    let $submitButtonWrap = document.querySelectorAll(".gform_footer")[0];
    let $submitButton = document.querySelectorAll(".gform_button")[0];

    $productDropdownSelect.addEventListener("change", function (e) {
      let target = e.target;
      optionValue = target.value;
      if ($dynamicMessage.classList.contains("show-dynamic-message")) {
        //if error message is showing remove disabling classes
        $dynamicMessage.classList.remove("show-dynamic-message");
        $submitButton.classList.remove("disable-gform-button");
        $submitButtonWrap.classList.remove("not-allowed");
      }
      $products.forEach(function (product) {
        //if a product title matches the value of select input
        if (product.title == optionValue) {
          //if download file and matching operating system value is true do nothing
          if (product.windows_download && operatingSystemValue == "Windows") {
            //do nothing if conditions are met
          } else if (
            product.linux_download &&
            operatingSystemValue == "Linux"
          ) {
            //do nothing if conditions are met
          } else if (product.zos_download && operatingSystemValue == "z/OS") {
            //do nothing if conditions are met
          } else {
            //if download file and matching operating system value is false show errors message / disable submit click
            $dynamicMessage.classList.add("show-dynamic-message");
            $submitButton.classList.add("disable-gform-button");
            $submitButtonWrap.classList.add("not-allowed");
          }
        }
      });
    });

    $operatingSystemSelect.addEventListener("change", function (event) {
      //change event for operating system
      operatingSystemValue = event.target.value;
      if ($dynamicMessage.classList.contains("show-dynamic-message")) {
        //if error message is showing remove disabling classes
        $dynamicMessage.classList.remove("show-dynamic-message");
        $submitButton.classList.remove("disable-gform-button");
        $submitButtonWrap.classList.remove("not-allowed");
      }
      $products.forEach(function (product) {
        //if a product title matches the value of select input
        if (product.title == optionValue) {
          //if download file and matching operating system value is true do nothing
          if (product.windows_download && operatingSystemValue == "Windows") {
            //do nothing if conditions are met
          } else if (
            product.linux_download &&
            operatingSystemValue == "Linux"
          ) {
            //do nothing if conditions are met
          } else if (product.zos_download && operatingSystemValue == "z/OS") {
            //do nothing if conditions are met
          } else {
            //if download file and matching operating system value is false show errors message / disable submit click
            $dynamicMessage.classList.add("show-dynamic-message");
            $submitButton.classList.add("disable-gform-button");
            $submitButtonWrap.classList.add("not-allowed");
          }
        }
      });
    });
  }, 100);
}
